/**
 * Eine Liste in Blöcke fester Größe zerlegen.
 *
 * Gebraucht für Sammel-Aufrufe: die Massenlöschung der Mediathek schickte eine Anfrage JE Datei
 * und erzeugte aus einem Klick auf 200 ausgewählte Dateien 202 Anfragen — mehr als der globale
 * Begrenzer je Konto und 15 Minuten durchlässt (100). Seither geht die Auswahl blockweise an einen
 * Sammel-Endpunkt, und die Rechnung dafür steht hier.
 *
 * ⚠️ Warum als eigene Datei und nicht im Bauteil: `react-refresh/only-export-components` verbietet
 * einer Bauteil-Datei zu Recht, nebenbei Funktionen zu exportieren — Fast Refresh arbeitet dann
 * nicht mehr. Und die Rechnung soll prüfbar sein, ohne 201 Dateizeilen in jsdom aufzubauen: genau
 * dieser Oberflächen-Test lief in der vollen Suite in seine Zeitschranke und war mal rot, mal grün.
 * Eine Prüfung, die je nach Auslastung der Maschine kippt, prüft nichts.
 */
export const inBlöcke = <T,>(werte: readonly T[], größe: number): T[][] => {
  if (größe < 1) throw new RangeError('Blockgröße muss mindestens 1 sein');
  const blöcke: T[][] = [];
  for (let i = 0; i < werte.length; i += größe) blöcke.push(werte.slice(i, i + größe));
  return blöcke;
};
